import { ChangeDetectionStrategy, Component, ElementRef, Injector, OnInit } from "@angular/core";
import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { UserService } from "@common/user/user.service";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";

@Component({
    selector: "adapt-personal-activity-feed-page",
    templateUrl: "./personal-activity-feed-page.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PersonalActivityFeedPageComponent extends BaseRoutedComponent implements OnInit {
    public person$ = this.userService.currentPerson$;

    public constructor(
        injector: Injector,
        elementRef: ElementRef,
        private userService: UserService,
    ) {
        super(injector, elementRef);
    }

    public ngOnInit() {
        this.notifyActivated();
    }
}

export const PersonalActivityFeedPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-personal-activity-feed-page", PersonalActivityFeedPageComponent)
    .atOrganisationUrl("/people/activity-feed")
    .verifyingFeatures(FeatureName.PlatformActivityFeeds)
    .withTitle("Activity Feed")
    .withSearchKeyword("activity")
    .withSearchKeyword("feed")
    .reloadOnSearch(false)
    .build();
